export const ID_OK = 1;
export const ID_VENCIDO = 2;
export const ID_PENDIENTE = 3;